import { render } from "./HeroView.vue?vue&type=template&id=c5597066"
import script from "./HeroView.vue?vue&type=script&lang=js"
export * from "./HeroView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__